import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormGroup, FormControl,Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import{UserService} from '../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements  OnInit {

  forgotFormGroup:FormGroup;
  username_error:string='';
  password_error:string='';
  group:Object={};
  showMe:boolean =false;
  token:any='';
  loader_image:boolean=false
  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";

  constructor(private _router: Router,private toastr: ToastrService,private route: ActivatedRoute,private _authService: AuthService,private userService:UserService,private formBuilder: FormBuilder) { 

   
  }

   
  checkInput(){
        
    if(this.forgotFormGroup.controls['txt_username_login'].status=="INVALID"){

      this.toastr.error('Please enter valid email address', '', {timeOut: 2000});

    }

  }

  ngOnInit() {

    this.group['txt_username_login']=new FormControl('',[Validators.required,Validators.pattern(this.emailPattern)]);
	
		
		this.forgotFormGroup =  this.formBuilder.group(this.group);
	
    
  }

  


  ngAfterViewInit(): void {
  
    $('.message a').click(function(e){
      e.preventDefault();
      
      $('form').animate({height: "toggle", opacity: "toggle"}, "slow");
   });

   $(document).ready(function(){ 
    $('input').blur(function(event) {
    var inputValue = this.value;
    if (inputValue) {
      this.classList.add('value-exists');
    } else {
      this.classList.remove('value-exists');
    }
    });
    });

  }

  forgot() {

    if(this.forgotFormGroup.status =='VALID'){

      let time = Math.round(+new Date()/1000).toString();

      let data={
        email:this.forgotFormGroup.value['txt_username_login'],
        page:'forgotpass',
        xtoken:btoa(time),
        forgot:true
      }

      this.loader_image=true
      

      this.userService.getUserList(data).subscribe( (res)=>{

        if(res.status=='success'){
          this.loader_image=false
          this.toastr.success('Password has been sent to your email address !', '', {timeOut: 3000});
          this._router.navigate(['/vlogin']);
  
        } else{
          this.toastr.error('Please check the email address and try again', '', {timeOut: 3000});
          this.loader_image=false
        }
  
     });
  

      // this._authService.login(data)
        
       
    }else{

      this.checkInput();
    }
    
  }

 

}
